module.exports = __webpack_public_path__ + "static/goliath_werebear-62ad1f70ce3c1a85c1763fca1a361e14.jpg";